import booker from './booker.js';
import addOn from './addOn.js';
import promotion from './promotion.js';
export default {
    'en-us': Object.assign({}, booker, addOn, promotion),
};
